import { useCallback, useRef } from 'react'
import { router, usePage } from '@inertiajs/react'
import type { SharedProps } from '@/frontend/types/inertia'

export function useOptionalInertiaProps() {
  const page = usePage<SharedProps>()
  const inFlightRef = useRef<Set<string>>(new Set())

  const hasProp = useCallback((prop: string) => (
    Object.prototype.hasOwnProperty.call(page.props, prop)
  ), [page.props])

  const loadProps = useCallback((props: string[], enabled = true) => {
    if (!enabled) return

    const missing = props.filter((prop) => !hasProp(prop) && !inFlightRef.current.has(prop))
    if (missing.length === 0) return

    missing.forEach((prop) => inFlightRef.current.add(prop))
    router.reload({
      only: missing,
      async: true,
      onFinish: () => {
        missing.forEach((prop) => inFlightRef.current.delete(prop))
      },
    })
  }, [hasProp])

  return { hasProp, loadProps }
}
